import type { PropsWithChildren } from 'react'

import { Flex, Spacer } from '@procurify/ui'

import {
  Breadcrumbs,
  type IBreadcrumbsProps,
} from '@webapp/core/components/Breadcrumbs'
import { PageTopContainerStyled } from './styles/PageTopContainerStyled'

export interface IPageTopContainerProps {
  breadcrumbs: IBreadcrumbsProps['crumbs']
}

export const PageTopContainer = ({
  breadcrumbs,
}: PropsWithChildren<IPageTopContainerProps>) => {
  return (
    <PageTopContainerStyled>
      <Flex.Row alignItems='center'>
        <Flex.Item>
          <Breadcrumbs crumbs={breadcrumbs} />
        </Flex.Item>
        <Flex.Item>
          <div id='page-badge-container' />
        </Flex.Item>
        <Flex.Item ml='auto'>
          <div id='page-action-container' />
        </Flex.Item>
      </Flex.Row>

      <Spacer />
    </PageTopContainerStyled>
  )
}

PageTopContainer.displayName = 'PageTopContainer'
